import apiClient from './api';

export default {
  getPosts(params = {}) {
    console.log('Making API request to get posts with params:', params);
    return apiClient.get('/blog/posts/', { params })
      .then(response => {
        console.log('API response for posts:', response);
        return response;
      })
      .catch(error => {
        console.error('API error for posts:', error);
        throw error;
      });
  },
  getPost(slug) {
    console.log(`Making API request to get post with slug: ${slug}`);
    return apiClient.get(`/blog/posts/${slug}/`)
      .then(response => {
        console.log('API response for single post:', response);
        return response;
      })
      .catch(error => {
        console.error(`API error for post with slug ${slug}:`, error);
        throw error;
      });
  }
};